import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { Feature } from '@nirvana/shared/constants';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class ReconfigureAgentActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_FRAT_VISIBLE])) {
      return false;
    }

    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    if (record.specifics.serverHasNsxIntegration) {
      return false;
    }

    if (record.isProtectedBySecurityContainer) {
      return false;
    }

    if (ProtectedEntitiesHelper.isUnifiedClient(record)) {
      if (ProtectedEntitiesHelper.isManagedByHviAndNotIsBest(record)) {
        return false;
      }

      return !record.specifics.isFratComputer;
    }

    if (ProtectedEntitiesHelper.isEpClient(record)) {
      return true;
    }

    if (ProtectedEntitiesHelper.isMacClient(record)) {
      return true;
    }

    return false;
  }
}
